<template>
  <div class="pa-10">
    <h1 class="mb-4">Werving</h1>
    <div
      style="
        display: grid;
        grid-template-columns: 2fr 3fr;
        gap: 25px;
        max-width: 1200px;
      "
    >
      <div style="max-width: 800px">
        <v-textarea
          rows="8"
          v-model="audience.description"
          label="Omschrijving"
        >
          <template v-slot:append-inner>
            <v-btn
              @click="getComplexity"
              icon="mdi-creation"
              variant="text"
              size="small"
            ></v-btn>
          </template>
        </v-textarea>
        <p>Aantal respondenten:</p>
        <v-slider
          v-model="audience.n"
          :min="1"
          :label="`${audience.n}`"
          :thumb-label="audience.n"
          :step="1"
        ></v-slider>
        <v-slider
          :ticks="
            rateCards
              .filter(
                (i) =>
                  i.item === 'incentive' && i.location === audience.location
              )
              .map((i) => i.time)
          "
          v-model="audience.time"
          :label="`${audience.time} minutes`"
          show-ticks="always"
          :thumb-label="audience.time"
          step="15"
          :min="
            Math.min(
              ...rateCards
                .filter((card) => card.item === 'incentive' && card.time)
                .map((card) => card.time)
            )
          "
          :max="
            Math.max(
              ...rateCards
                .filter((card) => card.item === 'incentive' && card.time)
                .map((card) => card.time)
            )
          "
        ></v-slider>
        <!-- <v-slider
          v-model="audience.days"
          :min="projectmanagement / 450"
          :label="`${audience.days} day(s)`"
          :step="1"
          max="10"
        ></v-slider> -->

        <div class="my-4">
          <v-btn-toggle v-model="audience.location">
            <v-btn value="remote">Remote</v-btn>
            <v-btn value="on location">Op locatie</v-btn>
          </v-btn-toggle>
        </div>
      </div>
      <div>
        <v-card class="mb-10 pa-10 bg-primary">
          <h2>Prijs:</h2>
          <p v-if="audience.complexity?.reason">
            De complexiteit voor deze werving is
            <b>{{ audience.complexity.complexity }}</b> met een zekerheid van
            {{ audience.complexity.confidence }}%.
          </p>
          <p>
            <u
              class="mb-2"
              style="cursor: pointer"
              v-if="audience.complexity?.reason"
              @click="beredenering = !beredenering"
              >Beredenering</u
            >
          </p>
          <v-expand-transition>
            <v-card v-show="beredenering" class="mt-2 pa-4">
              <div>
                <p style="font-size: 10pt">
                  <i>{{ audience.complexity.reason }}</i>
                </p>
              </div>
            </v-card>
          </v-expand-transition>

          <div class="d-flex my-5" style="gap: 10px">
            <v-card
              class="pa-5 d-flex flex-column align-center"
              v-for="c in complexity_options"
              :key="c.price"
              width="100"
              @click="audience.complexity = c"
              style="cursor: pointer"
              :class="{
                ' chosen elevation-10':
                  audience.complexity &&
                  c.complexity === audience.complexity.complexity,
                'bg-smoke':
                  !audience.complexity ||
                  c.complexity != audience.complexity?.complexity,
              }"
            >
              <v-img
                width="25"
                class="mb-3"
                :src="require(`@/assets/werving/${c.complexity}.avif`)"
              ></v-img>
              <h3>
                {{ c.text }}
              </h3>
            </v-card>
          </div>

          <div class="my-5">
            <p>Wervingskosten: €{{ wervingskosten }}</p>
            <p>
              Incentives: €{{ incentives }} €{{
                reiskosten ? `+ reiskosten: €${reiskosten}` : ""
              }}
            </p>
            <p>
              Project management: €{{ projectmanagement }} ({{
                projectmanagement / 450
              }}
              days)
            </p>
          </div>

          <div>
            <h2>Totaal: € {{ total }}</h2>
          </div>

          {{ complexity }}
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import rateCards from "./data/rateCards";
import { functions } from "@/firebase";
import { httpsCallable } from "firebase/functions";

export default {
  computed: {
    wervingskosten() {
      if (!this.audience.complexity) {
        return null;
      }
      console.log(this.audience);
      return (
        this.audience.n *
          this.rateCards.find(
            (i) =>
              i.item === "werving" &&
              i.complexity === this.audience.complexity.complexity
          ).price || null
      );
    },
    incentives() {
      return (
        this.audience.n *
          this.rateCards.find(
            (i) =>
              i.item === "incentive" &&
              i.location === this.audience.location &&
              i.time === this.audience.time
          ).price || null
      );
    },
    reiskosten() {
      return this.audience.location === "on location"
        ? this.audience.n *
            this.rateCards.find((i) => i.item === "Reiskosten").price
        : 0;
    },
    projectmanagement() {
      return Math.ceil((this.audience.n * this.audience.time) / 300) * 450;
    },
    total() {
      return this.wervingskosten + this.incentives + this.projectmanagement;
    },
  },
  data() {
    return {
      beredenering: false,
      audience: {
        description: null,
        n: 10,
        time: 45,
        location: "remote",
        confidence: null,
        complexity: {
          text: "Basic",
          price: 100,
          complexity: "basic",
        },
        days: 1,
      },
      time_options: [45, 60, 75],
      complexity_options: [
        {
          text: "Simpel",
          price: 75,
          complexity: "simpel",
        },
        {
          text: "Basic",
          price: 100,
          complexity: "basic",
        },
        {
          text: "Extra",
          price: 150,
          complexity: "extra",
        },
        {
          text: "Complex",
          price: 200,
          complexity: "complex",
        },
      ],
      rateCards: rateCards,
      complexity: null,
    };
  },
  methods: {
    async getComplexity() {
      this.$store.commit("setLoading", true);
      const classifyComplexity = httpsCallable(functions, "classifyComplexity");
      const res = await classifyComplexity({
        doelgroep: this.audience.description,
      });
      console.log(res.data);
      this.audience.complexity = res.data;
      this.$store.commit("setLoading", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.chosen {
  outline: 2px solid blue;
}
</style>
